export const DATE_FORMAT = 'yyyy-MM-dd';
export const SPEND_DELTA_THRESHOLD = 100;

export const MediaType = {
  STREAMING: 'streaming',
  AUDIO: 'audio',
  DISPLAY: 'display',
  TV: 'tv'
} as const;
export type MediaTypeType = (typeof MediaType)[keyof typeof MediaType];

export const CHANNELS = [MediaType.STREAMING, MediaType.AUDIO, MediaType.DISPLAY] as const;

// A row from /invoicing_companies — the client list backing the main checker table.
export interface InvoicingCompany {
  cid: string;
  name: string;
  MediaTypes: MediaTypeType[];
  commission?: number;
}

// A row from /invoicing_summary — a separate shape used only for the CSV summary export.
export interface InvoicingSummaryCompany {
  company: string;
  linearSpendTotal?: number;
  linearIconSpendTotal?: number;
  streamingImpressionsTotal?: number;
  audioImpressionsTotal?: number;
  displayImpressionsTotal?: number;
}

export interface CheckerResult {
  checking?: boolean;
  needsWizard: boolean;
  linearSpotDetailCount: number;
  invoiceSpend: number;
  strDeliv: number;
  audioDeliv: number;
  olvDeliv: number;
}

export interface DailyImpressionDiscrepancy {
  property?: string;
  platform: string;
  date: string;
  invoiceCount: number;
  deliveryCount: number;
  notes?: string;
}

export interface DeliveryComparisonRow {
  network: string;
  deliveryCost: number;
  deliveryCount: number;
  invoiceCost: number;
  invoiceCount: number;
  matched: boolean;
  imps: DailyImpressionDiscrepancy[];
}

export interface InvoicingInfo {
  needsWizard: boolean;
  linearSpotDetailCount: number;
  invoiceSpend: number;
}

export interface StreamingDeliveryNetwork {
  cost: number;
}

export interface GenerateLinearReportInput {
  company: string;
  commission?: number;
  isIconNetworks: boolean;
}
